/**
 * 区分 affiliationType（personnel.affiliation_type）
 * 出典：旧PCRM backend/src/shared/validation.ts の affiliationTypeSchema（旧の 6 つ・旧の並び。274：10/13 ユーザー判断で旧の値だけにした）
 * 新だけの値（contractEmployee 契約社員・businessPartner BP（協力会社所属））は消した。既存データは
 * apps/api/migration/274-a7-affiliation-type.ts で付け替える（BP は旧データの値へ、契約社員 → 正社員）。
 */
export const AFFILIATION_TYPE_VALUES = [
  'fullTime',
  'freelance',
  'firstTierEmployee',
  'secondTierEmployee',
  'thirdTierEmployee',
  'firstTierSoleProprietor',
] as const;

export type AffiliationType = (typeof AFFILIATION_TYPE_VALUES)[number];

export const AFFILIATION_TYPE_LABELS: Readonly<Record<AffiliationType, string>> = {
  fullTime: '正社員',
  freelance: 'フリーランス',
  firstTierEmployee: '1社先の社員',
  secondTierEmployee: '2社先の社員',
  thirdTierEmployee: '3社先の社員',
  firstTierSoleProprietor: '1社先個人事業主',
};

/**
 * 旧PCRM の affiliation_type（日本語の値）→ 新の値。移行（migrate-phase2.ts の M.affiliation）とデータ付け替えで使う。
 * 旧の 6 つに加え、旧の CSV 取込で入りうる「契約社員」は正社員へ寄せる（274：10/13 ユーザー判断）。
 * 旧の CSV で入った「BP」は旧の 6 つのどれか決められないため対応表に入れない（付け替えスクリプトで件数を出して人が決める）。
 */
export const LEGACY_AFFILIATION_TYPE_MAP: Readonly<Record<string, AffiliationType>> = {
  正社員: 'fullTime',
  フリーランス: 'freelance',
  '1社先の社員': 'firstTierEmployee',
  '2社先の社員': 'secondTierEmployee',
  '3社先の社員': 'thirdTierEmployee',
  '1社先個人事業主': 'firstTierSoleProprietor',
  契約社員: 'fullTime',
};
